export default __webpack_public_path__ + "static/media/arrowPrimary.b1a82a40.svg";